import { ColumnsType } from "antd/es/table";
import { FC } from "react";

import { TotalAccordion } from "@/shared/ui/TotalAccordion";
import {
    StyledTAColumnNameText,
    StyledTAValueText,
} from "@/shared/ui/TotalAccordion/Styled";

interface ITotalSumByAny {
    data: { key: string; form1: number; form2: number; total: number }[];
    title?: string | React.ReactNode;
}

export const TotalSumByAny: FC<ITotalSumByAny> = ({
    data,
    title = "Загальна сума",
}) => {
    const columns: ColumnsType<(typeof data)[0]> = [
        {
            title: <StyledTAColumnNameText>Форма 1</StyledTAColumnNameText>,
            dataIndex: "form1",
            key: "form1",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
        {
            title: <StyledTAColumnNameText>Форма 2</StyledTAColumnNameText>,
            dataIndex: "form2",
            key: "form2",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
        {
            title: <StyledTAColumnNameText>Разом</StyledTAColumnNameText>,
            dataIndex: "total",
            key: "total",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
    ];
    return (
        <TotalAccordion
            data={data}
            columns={columns}
            getTotalValue={(data) => data[0]?.total || 0}
            title={title}
        />
    );
};
